{
    "BroadworksProvisioningHeader": "Aprovisionamento do Pacote de Serviços Broadworks",
    "BroadworksProvisioningTableHeaderEnabled": "Ativado",
    "BroadworksProvisioningTableHeaderItem": "Item",
    "BroadworksProvisioningTableHeaderServicePack": "Pacote de Serviços",
    "BroadworksProvisioningTableHeaderTelephonyServers": "Servidor(es) de telefonia",
    "BroadworksProvisioningAddEntry": "Adicionar entrada...",
    "BroadworksProvisioningItemExtension": "Extensão",
    "BroadworksProvisioningItemHospitality": "Hotelaria",
    "BroadworksProvisioningItemAcdAgent": "Agente ACD",
    "BroadworksProvisioningButtonDiscardChanges": "Descartar alterações",
    "BroadworksProvisioningButtonSave": "Gravar",
    "BroadworksProvisioningButtonActions": "Ações",
    "BroadworksProvisioningButtonDelete": "remover",
    "BroadworksProvisioningButtonEdit": "Editar",
    "BroadworksProvisioningValueIsRequired": "Valor é requerido.",
    "NAME": "Provisioning",
    "BroadworksProvisioningTableHeaderSendWelcomeEmail": "Enviar e-mail de boas-vindas",
    "BroadworksProvisioningItemEssentials": "Essenciais",
    "BroadworksProvisioningItemProfessional": "Profissional",
    "BroadworksProvisioningItemCallCentreAgent": "Agente do Call Center",
    "BroadworksProvisioningItemEnterprise": "Empresa",
    "BroadworksProvisioningItemCallCentreSupervisor": "Supervisor do Call Center",
    "BroadworksProvisioningItem1000": "Akixi 1000",
    "BroadworksProvisioningItem2000": "Akixi 2000"
}